module.exports = __webpack_public_path__ + "img/8.a5355d86.webp";